const MINUTE_MS = 60_000;

export const STALE_TIME_ONE_MINUTE_MS = MINUTE_MS;
export const STALE_TIME_FIVE_MINUTES_MS = 5 * MINUTE_MS;
